import React from "react";
import './icon-card-style.css'
const IconCardStyle = ({ title, content, image,height}) =>  {

return (
<>
 <div className="icon-card"  style={{ height: height }}>
    <img className="my-3"  src={image} alt={title || ''} width="65px" height="52px"/>
    <h5 class="item-title">{title}</h5>
    <p className="content_margin item-content main-content">{content}</p>
 </div>
      
</>
);
}
export default IconCardStyle;